module.exports = __webpack_public_path__ + "img/frame (22).4302d89f.jpg";